"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _SliderWithInput = require("@ccw-pwa-ui/SliderWithInput");
var _NavigateBackButton = require("@ccw-pwa-ui/NavigateBackButton");
var _ConnectionLoader = require("@ccw-pwa-ui/ConnectionLoader");
var _Modal = require("@ccw-pwa-ui/Modal");
var _HeaderText = require("@ccw-pwa-ui/HeaderText");
var _react = _interopRequireDefault(require("react"));
var _reactDatepicker = _interopRequireDefault(require("react-datepicker"));
require("../styles/EditAccessoryComponent.css");
var _index = _interopRequireDefault(require("../common_features/assets/images/index"));
var _Button = require("@ccw-pwa-ui/Button");
const EditAccessoryComponent = _ref => {
  let {
    totalPage,
    currentPage,
    sequence,
    handleBack,
    headerText,
    subContent,
    inputLabel,
    dateChange,
    value,
    saveBtnTitle,
    saveBtnClick,
    saveBtnDisabled,
    removeSensorButtonText,
    removeBtnClick,
    removeBtnDisabled,
    leftArrow,
    backNavigationScreen,
    edit,
    editSliderLabel,
    warningModal,
    handleInputValue,
    inputValue,
    isUpdating,
    warningModalData,
    errorModal,
    saveErrorModalData,
    saveErrorModal,
    sliderMin,
    sliderMax,
    inputNumberMin,
    inputNumberMax,
    sliderLeftText,
    sliderRightText,
    pname,
    adjustReplacementText,
    rightNavHeading,
    handleCancle,
    minInstallationDate,
    maxInstallationDate,
    modelNumber,
    pageNumberNotShow,
    isPartial
  } = _ref;
  return isUpdating ? /*#__PURE__*/_react.default.createElement(_ConnectionLoader.ConnectionLoader, null) : /*#__PURE__*/_react.default.createElement("div", {
    className: "edit-accessory-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_NavigateBackButton.NavigateBackButton, {
    navHeading: backNavigationScreen,
    handleBack: handleBack,
    rightNavHeading: rightNavHeading,
    handleCancle: handleCancle,
    leftArrowImage: _index.default.leftArrow.default
  }), !pageNumberNotShow ? /*#__PURE__*/_react.default.createElement("div", {
    className: "PageCount"
  }, /*#__PURE__*/_react.default.createElement("span", {
    style: {
      fontWeight: 600
    }
  }, "Step ", currentPage, " "), " of ", totalPage) : null, /*#__PURE__*/_react.default.createElement("div", {
    className: "edit-accessory-bodyWrapper"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "edit-accessory-body"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: !pageNumberNotShow ? "edit-accessory-header" : "edit-accessory-header-2"
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    variant: "header-text",
    headerText: headerText
  })), pname && /*#__PURE__*/_react.default.createElement("div", {
    className: "edit-accessory-pname"
  }, pname), /*#__PURE__*/_react.default.createElement("div", {
    className: "edit-accessory-subContent"
  }, subContent), /*#__PURE__*/_react.default.createElement("div", {
    className: "model-number-label"
  }), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    className: "edit-input-label"
  }, inputLabel), /*#__PURE__*/_react.default.createElement("div", {
    className: "edit-accessory-date-picker",
    "data-testid": "subSteper-date-picker"
  }, /*#__PURE__*/_react.default.createElement(_reactDatepicker.default, {
    placeholderText: "Select Date",
    className: "edit-accessory-date"
    // selected={new Date(value || new Date())}
    ,
    selected: value,
    onChange: date => dateChange(date, sequence),
    maxDate: maxInstallationDate,
    minDate: minInstallationDate
    // minDate={new Date(moment().subtract(1, "months"))}
  }), /*#__PURE__*/_react.default.createElement("img", {
    src: _index.default.Union.default,
    alt: "",
    className: "email-icon2"
  }))), edit && /*#__PURE__*/_react.default.createElement("div", {
    className: "edit-accessory-slider-wrapper"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "edit-accessory-editSliderLabel"
  }, editSliderLabel), /*#__PURE__*/_react.default.createElement("div", {
    className: "edit-accessory-slider"
  }, /*#__PURE__*/_react.default.createElement(_SliderWithInput.SliderWithInput, {
    handleInputValue: value => handleInputValue(value, sequence),
    inputValue: inputValue,
    sliderMin: sliderMin,
    sliderMax: sliderMax,
    inputNumberMin: inputNumberMin,
    inputNumberMax: inputNumberMax,
    sliderLeftText: sliderLeftText,
    sliderRightText: sliderRightText
  }))), adjustReplacementText && /*#__PURE__*/_react.default.createElement("div", {
    className: "adjustReplacementText"
  }, adjustReplacementText), /*#__PURE__*/_react.default.createElement("div", {
    className: "edit-accessory-btn-wrapper"
  }, saveBtnTitle && /*#__PURE__*/_react.default.createElement("div", {
    className: "edit-accessory-savebtn",
    "data-testid": "edit-accessory-savebtn"
  }, /*#__PURE__*/_react.default.createElement(_Button.Button, {
    variant: "primary-long",
    title: saveBtnTitle,
    onClick: saveBtnClick,
    disabled: saveBtnDisabled
  })), isPartial && removeSensorButtonText && /*#__PURE__*/_react.default.createElement("div", {
    className: "edit-accessory-removebtn",
    "data-testid": "edit-accessory-removebtn"
  }, /*#__PURE__*/_react.default.createElement(_Button.Button, {
    variant: "outline-primary-long",
    title: removeSensorButtonText,
    onClick: removeBtnClick,
    disabled: removeBtnDisabled,
    borderWidth: '2px'
  }))))), (warningModal || errorModal) && /*#__PURE__*/_react.default.createElement("div", {
    className: ""
  }, /*#__PURE__*/_react.default.createElement(_Modal.Modal, {
    displayModal: warningModalData === null || warningModalData === void 0 ? void 0 : warningModalData.displayModal,
    modalHeaderText: warningModalData === null || warningModalData === void 0 ? void 0 : warningModalData.modalHeaderText,
    modalHeaderTextStyle: warningModalData === null || warningModalData === void 0 ? void 0 : warningModalData.modalHeaderTextStyle,
    modalDetailText: warningModalData === null || warningModalData === void 0 ? void 0 : warningModalData.modalDetailText,
    modalHeaderIcon: warningModalData === null || warningModalData === void 0 ? void 0 : warningModalData.modalHeaderIcon,
    displayCrossIcon: warningModalData === null || warningModalData === void 0 ? void 0 : warningModalData.displayCrossIcon,
    variant: warningModalData === null || warningModalData === void 0 ? void 0 : warningModalData.variant,
    positiveActionButtonTitle: warningModalData === null || warningModalData === void 0 ? void 0 : warningModalData.positiveActionButtonTitle,
    positiveAction: warningModalData === null || warningModalData === void 0 ? void 0 : warningModalData.positiveAction,
    negativeButtonActionTitle: warningModalData === null || warningModalData === void 0 ? void 0 : warningModalData.negativeButtonActionTitle,
    crossIconAction: warningModalData === null || warningModalData === void 0 ? void 0 : warningModalData.crossIconAction,
    negativeAvtion: warningModalData === null || warningModalData === void 0 ? void 0 : warningModalData.negativeAvtion
  })), saveErrorModal && /*#__PURE__*/_react.default.createElement(_Modal.Modal, {
    displayModal: saveErrorModalData === null || saveErrorModalData === void 0 ? void 0 : saveErrorModalData.displayModal,
    modalHeaderText: saveErrorModalData === null || saveErrorModalData === void 0 ? void 0 : saveErrorModalData.modalHeaderText,
    modalHeaderTextStyle: saveErrorModalData === null || saveErrorModalData === void 0 ? void 0 : saveErrorModalData.modalHeaderTextStyle,
    modalDetailText: saveErrorModalData === null || saveErrorModalData === void 0 ? void 0 : saveErrorModalData.modalDetailText,
    modalHeaderIcon: saveErrorModalData === null || saveErrorModalData === void 0 ? void 0 : saveErrorModalData.modalHeaderIcon,
    displayCrossIcon: saveErrorModalData === null || saveErrorModalData === void 0 ? void 0 : saveErrorModalData.displayCrossIcon,
    variant: saveErrorModalData === null || saveErrorModalData === void 0 ? void 0 : saveErrorModalData.variant,
    positiveActionButtonTitle: saveErrorModalData === null || saveErrorModalData === void 0 ? void 0 : saveErrorModalData.positiveActionButtonTitle,
    positiveAction: saveErrorModalData === null || saveErrorModalData === void 0 ? void 0 : saveErrorModalData.positiveAction,
    negativeButtonActionTitle: saveErrorModalData === null || saveErrorModalData === void 0 ? void 0 : saveErrorModalData.negativeButtonActionTitle,
    crossIconAction: saveErrorModalData === null || saveErrorModalData === void 0 ? void 0 : saveErrorModalData.crossIconAction,
    negativeAvtion: saveErrorModalData === null || saveErrorModalData === void 0 ? void 0 : saveErrorModalData.negativeAvtion
  }));
};
var _default = exports.default = EditAccessoryComponent;